import { createContext, useContext, useState } from "react";
import SidebarHeader from "./SidebarHeader";
import SidebarListContent from "./SidebarListContent";
import { cn } from "../../lib/utils";
import SidebarCard from "./SidebarCard";
import SidebarFilterToggle from "./SidebarFilterToggle";
import SidebarActionButton from "./SidebarActionButton";
import SidebarFilterContent from "./SidebarFilterContent";

const SidebarContext = createContext({});
export const useSidebar = () => useContext(SidebarContext);

function SidebarComponent({ children, className }) {
	return (
		<div
			className={cn(
				"fixed h-full w-[450px] max-w-[450px] pt-[64px] shadow-[1px_0_0] shadow-dark-10 top-0 flex z-[13] flex-col",
				className
			)}
		>
			{children}
		</div>
	);
}

/**
 * @param {{ children: React.ReactNode, className?: string, side?: "left" | "right", hasFilterApplied?: boolean }} props
 */
function Sidebar({ children, side = "left", className, ...props }) {
	const [isFilterOpen, setIsFilterOpen] = useState(false);

	const toggleFilterOpen = () => {
		setIsFilterOpen((is) => !is);
	};

	return (
		<SidebarContext.Provider value={{ side, ...props, toggleFilterOpen, isFilterOpen }}>
			<SidebarComponent className={className}>{children}</SidebarComponent>
		</SidebarContext.Provider>
	);
}

Sidebar.displayName = "Sidebar";
Sidebar.Header = SidebarHeader;
Sidebar.List = SidebarListContent;
Sidebar.Card = SidebarCard;
Sidebar.FilterToggle = SidebarFilterToggle;
Sidebar.ActionButton = SidebarActionButton;
Sidebar.FilterContent = SidebarFilterContent;

export default Sidebar;
